import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initDocument(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPIC_TAGS_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/topic_tag`, {
          withCredentials: true,
        })
        .then(response => response.data),
  );
}
